"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable react/jsx-props-no-spreading */
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const isFunction_1 = __importDefault(require("lodash/isFunction"));
const Dialog_1 = __importDefault(require("../Dialog/Dialog"));
const constants_1 = require("../../constants");
const TooltipConstants_1 = require("./TooltipConstants");
require("./Tooltip.scss");
// When last tooltip was shown in the last 1.5 second - the next tooltip will be shown immediately
const IMMEDIATE_SHOW_THRESHOLD_MS = 1500;
// Shared state across multiple tooltip instances (i.e last tooltip shown time)
const globalState = {
    lastTooltipHideTS: null,
    openTooltipsCount: 0
};
class Tooltip extends react_1.PureComponent {
    constructor(props) {
        super(props);
        this.renderTooltipContent = this.renderTooltipContent.bind(this);
        this.getShowDelay = this.getShowDelay.bind(this);
        this.onTooltipShow = this.onTooltipShow.bind(this);
        this.onTooltipHide = this.onTooltipHide.bind(this);
        this.wasShown = false;
    }
    getContainer() {
        return document.getElementById("tooltips-container") || document.querySelector("body");
    }
    renderTooltipContent() {
        const { theme, content, paddingSize, className, style } = this.props;
        if (!content) {
            // don't render empty tooltip
            return null;
        }
        let contentValue;
        if ((0, isFunction_1.default)(content)) {
            contentValue = content();
        }
        else if ((0, react_1.isValidElement)(content)) {
            contentValue = content;
        }
        else if (typeof content === "string" && content) {
            contentValue = content;
        }
        if (!contentValue) {
            return null;
        }
        return ((0, jsx_runtime_1.jsx)("div", Object.assign({ style: style, className: (0, classnames_1.default)(`monday-style-tooltip monday-style-tooltip-${theme} padding-size-${paddingSize}`, className) }, { children: contentValue })));
    }
    onTooltipShow() {
        if (!this.wasShown) {
            const { onTooltipShow } = this.props;
            globalState.openTooltipsCount++;
            this.wasShown = true;
            onTooltipShow && onTooltipShow();
        }
    }
    onTooltipHide() {
        if (this.wasShown) {
            const { onTooltipHide } = this.props;
            globalState.lastTooltipHideTS = Date.now();
            globalState.openTooltipsCount--;
            this.wasShown = false;
            onTooltipHide && onTooltipHide();
        }
    }
    getTimeSinceLastTooltip() {
        if (globalState.openTooltipsCount > 0) {
            return 0;
        }
        return globalState.lastTooltipHideTS ? Date.now() - globalState.lastTooltipHideTS : Infinity;
    }
    getShowDelay() {
        const { showDelay, immediateShowDelay } = this.props;
        const timeSinceLastTooltip = this.getTimeSinceLastTooltip();
        if ((immediateShowDelay === 0 || immediateShowDelay) && timeSinceLastTooltip < IMMEDIATE_SHOW_THRESHOLD_MS) {
            // showing the tooltip immediately (without animation)
            return {
                showDelay: immediateShowDelay,
                preventAnimation: true
            };
        }
        return {
            showDelay,
            preventAnimation: false
        };
    }
    render() {
        const { withoutDialog, moveBy, justify, children, getContainer, theme, paddingSize, tip, showTrigger, hideTrigger, showOnDialogEnter } = this.props;
        if (!children) {
            return null;
        }
        if (withoutDialog) {
            return this.renderTooltipContent();
        }
        const content = this.renderTooltipContent;
        const dialogProps = Object.assign(Object.assign({}, this.props), { startingEdge: justify, tooltip: tip, content, getContainer: getContainer || this.getContainer, moveBy, tooltipClassName: `monday-style-arrow monday-style-arrow-${theme} padding-size-${paddingSize}`, animationType: "expand", onDialogDidHide: this.onTooltipHide, onDialogDidShow: this.onTooltipShow, getDynamicShowDelay: this.getShowDelay, showTrigger,
            hideTrigger,
            showOnDialogEnter });
        return (0, jsx_runtime_1.jsx)(Dialog_1.default, Object.assign({}, dialogProps, { children: children }));
    }
}
exports.default = Tooltip;
Tooltip.positions = constants_1.DialogPosition;
Tooltip.themes = TooltipConstants_1.TooltipTheme;
Tooltip.animationTypes = constants_1.AnimationType;
Tooltip.justifyTypes = constants_1.JustifyType;
Tooltip.arrowPositions = TooltipConstants_1.TooltipArrowPosition;
Tooltip.defaultProps = {
    arrowPosition: TooltipConstants_1.TooltipArrowPosition.CENTER,
    moveBy: { main: 4, secondary: 0 },
    theme: TooltipConstants_1.TooltipTheme.Dark,
    position: Tooltip.positions.TOP,
    justify: Tooltip.justifyTypes.CENTER,
    hideDelay: 0,
    showDelay: 300,
    disableDialogSlide: true,
    animationType: constants_1.AnimationType.EXPAND,
    withoutDialog: false,
    containerSelector: "#tooltips-container",
    tip: true,
    hideWhenReferenceHidden: false,
    modifiers: new Array(),
    showTrigger: Dialog_1.default.hideShowTriggers.MOUSE_ENTER,
    hideTrigger: Dialog_1.default.hideShowTriggers.MOUSE_LEAVE,
    showOnDialogEnter: false,
    referenceWrapperClassName: ""
};
